import { reactive, toRefs } from 'vue'
import { Message } from 'view-design'
import { clone } from '@/common/js/just'
import { useTableHelpers } from './useTableHelpers'

export function useBatchBid(selectList) {
  const { rowBidValueFmt } = useTableHelpers()

  const state = reactive({
    batcModifyBidRows: [],
    bidModifyModal: false
  })

  const formatBidValue = (row) => {
    const bid = rowBidValueFmt(row.bid)
    const deepCpabid = rowBidValueFmt(row.deepCpabid)
    const roiRatio = rowBidValueFmt(row.roiRatio)
    const projectTargetBid = rowBidValueFmt(row.projectTargetBid)
    const projectDeepBid = rowBidValueFmt(row.projectDeepBid)
    const projectRoi = rowBidValueFmt(row.projectRoi)
    return { bid, deepCpabid, roiRatio, projectTargetBid, projectDeepBid, projectRoi }
  }

  const makeBatchBidRows = (rows) => {
    return rows.map((s) => {
      // submitResult会在接口提交后与原本的list进行合并
      const { submitResult } = s

      // 转换为空值为 - 显示
      const { bid, deepCpabid, roiRatio, projectTargetBid, projectDeepBid, projectRoi } = formatBidValue(s)

      const editStates = {}
      // 目前只有头条uba可以修改项目出价、roi
      editStates.projectTargetBid = {
        // projectBidStatus = -1 表示接口提交未修改
        // projectBidStatus = 1 表示接口提交修改成功，不能在当前弹窗再次修改
        unchange: submitResult?.projectBidStatus === -1,
        success: submitResult?.projectBidStatus === 1,
        // 可以编辑的情况：
        // projectTargetBid > 0 表示项目已有出价
        // submitResult不存在，表示还未批量提交；如果前一个条件成立 （projectTargetBid > 0） 就能编辑出价
        // projectBidStatus = 2 表示接口提交修改失败，需要修改后再次提交重试
        editable: projectTargetBid > 0 && (!submitResult || submitResult.projectBidStatus === 2)
      }
      editStates.projectDeepBid = {
        unchange: submitResult?.projectDeepBidStatus === -1,
        success: submitResult?.projectDeepBidStatus === 1,
        editable: projectDeepBid > 0 && (!submitResult || submitResult.projectDeepBidStatus === 2)
      }
      editStates.projectRoi = {
        unchange: submitResult?.projectRoibidStatus === -1,
        success: submitResult?.projectRoibidStatus === 1,
        editable: projectRoi > 0 && (!submitResult || submitResult.projectRoibidStatus === 2)
      }

      editStates.bid = {
        unchange: submitResult?.adBidStatus === -1,
        success: submitResult?.adBidStatus === 1,
        editable: bid > 0 && (!submitResult || submitResult.adBidStatus === 2)
      }

      editStates.deepCpabid = {
        unchange: submitResult?.adDeepbidStatus === -1,
        success: submitResult?.adDeepbidStatus === 1,
        editable: deepCpabid > 0 && (!submitResult || submitResult.adDeepbidStatus === 2)
      }

      editStates.roiRatio = {
        unchange: submitResult?.adRoibidStatus === -1,
        success: submitResult?.adRoibidStatus === 1,
        editable: roiRatio > 0 && (!submitResult || submitResult.adRoibidStatus === 2)
      }

      return {
        ...s,
        editStates
      }
    })
  }

  const updateBatchBidRows = (rows) => {
    state.batcModifyBidRows = makeBatchBidRows(rows)
  }

  const showPlanBatchBidModal = () => {
    if (!selectList.value?.length) return Message.info('请选择至少一个计划！')
    state.bidModifyModal = true

    let rows = clone(selectList.value)

    // 第一次打开弹窗时，处理表格行显示的出价数据，并添加result对象作为存储修改后的出价值
    rows = rows.map((s) => {
      // 转换为空值为 - 显示
      const { bid, deepCpabid, roiRatio, projectTargetBid, projectDeepBid, projectRoi } = formatBidValue(s)

      return {
        ...s,
        // 覆盖掉原始值
        bid,
        deepCpabid,
        roiRatio,
        projectTargetBid,
        projectDeepBid,
        projectRoi,

        retryLoading: false, // 行内重试loading

        // 接收修改后的出价值model
        result: {
          projectTargetBid,
          projectDeepBid,
          bid,
          deepCpabid,
          roiRatio,
          projectRoi
        }
      }
    })
    // 第一次打开弹窗时，为表格行新增 editStates 编辑状态
    rows = makeBatchBidRows(rows)
    state.batcModifyBidRows = rows
  }

  return {
    ...toRefs(state),
    formatBidValue,
    makeBatchBidRows,
    updateBatchBidRows,
    showPlanBatchBidModal
  }
}
